import React from 'react';
import { ArrowLeftIcon, CheckCircleIcon, FileTextIcon, ShieldCheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function GiftAidDetails() {
  // Mock data for the GiftAid details
  const giftAidData = {
    enabled: true,
    dateEnabled: '15 March 2023',
    nationalInsuranceNumber: 'AB 12 34 56 C',
    taxPayer: true,
    address: '123 High Street, Cambridge, CB1 2AB',
    lastDeclaration: '15 March 2023',
    donationsEnhanced: 42,
    totalAdditionalDonated: '£156.75'
  };
  return <div className="space-y-6" data-id="element-338">
      <div className="flex items-center" data-id="element-339">
        <Link to="/" className="flex items-center text-primary hover:text-primary/80 transition-colors mr-4" data-id="element-340">
          <ArrowLeftIcon className="w-5 h-5 mr-1" data-id="element-341" />
          <span data-id="element-342">Back</span>
        </Link>
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-343">
          GiftAid Details
        </h1>
      </div>
      <div className="bg-card rounded-xl shadow-sm p-6" data-id="element-344">
        <div className="flex items-center mb-6" data-id="element-345">
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mr-4" data-id="element-346">
            <ShieldCheckIcon className="w-6 h-6 text-primary" data-id="element-347" />
          </div>
          <div data-id="element-348">
            <h2 className="text-xl font-bold text-text-primary" data-id="element-349">
              GiftAid Declaration
            </h2>
            <p className="text-text-secondary" data-id="element-350">
              Your GiftAid declaration allows Cauri to claim an extra 25% on
              your donations
            </p>
          </div>
          <div className="ml-auto" data-id="element-351">
            <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium flex items-center" data-id="element-352">
              <CheckCircleIcon className="w-4 h-4 mr-1" data-id="element-353" />
              Active
            </span>
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-354">
          <div className="space-y-4" data-id="element-355">
            <div data-id="element-356">
              <h3 className="text-sm text-text-secondary font-medium mb-1" data-id="element-357">
                National Insurance Number
              </h3>
              <p className="text-text-primary font-mono bg-gray-50 p-2 rounded border border-gray-200" data-id="element-358">
                {giftAidData.nationalInsuranceNumber}
              </p>
            </div>
            <div data-id="element-359">
              <h3 className="text-sm text-text-secondary font-medium mb-1" data-id="element-360">
                UK Tax Payer
              </h3>
              <p className="text-text-primary flex items-center" data-id="element-361">
                <CheckCircleIcon className="w-5 h-5 text-green-500 mr-1" data-id="element-362" />
                Yes, I pay UK Income or Capital Gains Tax
              </p>
            </div>
            <div data-id="element-363">
              <h3 className="text-sm text-text-secondary font-medium mb-1" data-id="element-364">
                Registered Address
              </h3>
              <p className="text-text-primary" data-id="element-365">{giftAidData.address}</p>
            </div>
          </div>
          <div className="space-y-4" data-id="element-366">
            <div data-id="element-367">
              <h3 className="text-sm text-text-secondary font-medium mb-1" data-id="element-368">
                Declaration Date
              </h3>
              <p className="text-text-primary" data-id="element-369">{giftAidData.dateEnabled}</p>
            </div>
            <div data-id="element-370">
              <h3 className="text-sm text-text-secondary font-medium mb-1" data-id="element-371">
                Last Declaration
              </h3>
              <p className="text-text-primary" data-id="element-372">{giftAidData.lastDeclaration}</p>
            </div>
            <div data-id="element-373">
              <h3 className="text-sm text-text-secondary font-medium mb-1" data-id="element-374">
                Impact
              </h3>
              <div className="bg-primary/5 p-3 rounded-lg" data-id="element-375">
                <p className="text-text-primary mb-1" data-id="element-376">
                  <span className="font-bold" data-id="element-377">
                    {giftAidData.donationsEnhanced}
                  </span>{' '}
                  donations enhanced with GiftAid
                </p>
                <p className="text-text-primary" data-id="element-378">
                  <span className="font-bold" data-id="element-379">
                    {giftAidData.totalAdditionalDonated}
                  </span>{' '}
                  additional funds donated to causes
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-100" data-id="element-380">
          <div className="flex items-start" data-id="element-381">
            <FileTextIcon className="w-5 h-5 text-text-secondary mt-0.5 mr-3 flex-shrink-0" data-id="element-382" />
            <div className="text-sm text-text-secondary" data-id="element-383">
              <p className="mb-2" data-id="element-384">
                I confirm I am a UK taxpayer and understand that if I pay less
                Income Tax and/or Capital Gains Tax than the amount of Gift Aid
                claimed on all my donations in that tax year it is my
                responsibility to pay any difference.
              </p>
              <p data-id="element-385">
                I understand the charity will reclaim 25p of tax on every £1
                that I give.
              </p>
            </div>
          </div>
          <div className="mt-6 flex space-x-4" data-id="element-386">
            <button className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary/90 transition-colors" data-id="element-387">
              Update Declaration
            </button>
            <button className="px-4 py-2 border border-gray-200 text-text-primary rounded-lg hover:bg-gray-50 transition-colors" data-id="element-388">
              Cancel Declaration
            </button>
          </div>
        </div>
      </div>
    </div>;
}